"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var styled_1 = __importDefault(require("@emotion/styled"));
var Box_1 = __importDefault(require("../Box"));
var FormRow = (0, styled_1.default)(Box_1.default)(function (_a) {
    var _b;
    var theme = _a.theme, breakpoint = _a.breakpoint;
    var rowStyle = {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'flex-end',
        gap: '20px',
    };
    if (!breakpoint) {
        return rowStyle;
    }
    return _b = {
            display: "flex",
            flexDirection: 'column',
            alignItems: 'stretch',
            gap: '0px'
        },
        _b["" + theme.mediaQueries[breakpoint]] = __assign({}, rowStyle),
        _b;
});
exports.default = FormRow;
